<script setup>
import { useToast } from '@/composables/useToast'
const { toasts, remove } = useToast()

const icons = { success: 'check_circle', error: 'error', warning: 'warning' }
const styles = {
  success: 'bg-surface-container border-tertiary text-tertiary',
  error:   'bg-surface-container border-error text-error',
  warning: 'bg-surface-container border-yellow-500 text-yellow-500',
}
const textStyles = {
  success: 'text-on-surface',
  error:   'text-on-surface',
  warning: 'text-on-surface',
}
</script>

<template>
  <teleport to="body">
    <div class="fixed top-6 right-6 z-50 flex flex-col gap-3 pointer-events-none">
      <transition-group tag="div" name="toast" class="contents">
        <div
          v-for="t in toasts"
          :key="t.id"
          :class="['toast-item flex items-start gap-3 px-4 py-3 rounded-xl border-l-4 shadow-2xl shadow-black/50 min-w-72 max-w-sm pointer-events-auto', styles[t.type]]"
        >
          <span class="material-symbols-outlined text-base mt-0.5 flex-shrink-0">{{ icons[t.type] }}</span>
          <span :class="['text-sm flex-1 whitespace-pre-line', textStyles[t.type]]">{{ t.message }}</span>
          <button
            @click="remove(t.id)"
            class="opacity-50 hover:opacity-100 transition-opacity flex-shrink-0"
          >
            <span class="material-symbols-outlined text-base">close</span>
          </button>
        </div>
      </transition-group>
    </div>
  </teleport>
</template>

<style scoped>
.toast-item {
  animation: toast-in 0.25s ease forwards;
}
.toast-enter-active,
.toast-leave-active {
  animation: none;
}
.toast-leave-active {
  animation: toast-out 0.25s ease forwards;
}
@keyframes toast-in {
  from { opacity: 0; transform: translateX(60px); }
  to   { opacity: 1; transform: translateX(0); }
}
@keyframes toast-out {
  from { opacity: 1; transform: translateX(0); }
  to   { opacity: 0; transform: translateX(60px); }
}
</style>
